"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const checkbox_1 = require("components/cosmos/checkbox");
const translate_1 = require("components/translate");
const classesModuleTooltip_1 = __importDefault(require("modules/content/tracks/view/classesModuleTooltip"));
const modulePageList_1 = require("./modulePageList");
const moduleListContext_1 = require("../moduleListContext");
const ModuleItem = ({ t, module, isLast, className, showClassesTooltip, productId }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isLoadingPages, setIsLoadingPages] = (0, react_1.useState)(false);
    const { onModuleCollapse, onModuleChange } = (0, moduleListContext_1.useModuleListContext)();
    const handleChange = (event) => {
        onModuleChange === null || onModuleChange === void 0 ? void 0 : onModuleChange(module.id, event);
    };
    const handleClick = async (event) => {
        const newIsOpen = !isOpen;
        event.currentTarget.blur();
        setIsOpen(newIsOpen);
        if (onModuleCollapse) {
            setIsLoadingPages(true);
            await onModuleCollapse(newIsOpen, module.id);
            setIsLoadingPages(false);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('_pt-4 _rounded-lg _border _border-gray-200', { '_bg-white': !module.isDisabled }, className), children: (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column", children: [(0, jsx_runtime_1.jsx)("div", { className: "_pl-8 _pr-4 _d-flex _align-items-center _justify-content-between", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(checkbox_1.Checkbox, { id: `checkbox-module-${module.id}`, label: module.title, labelClassName: (0, classnames_1.default)('_text-gray-700 _font-weight-bold _text-2', { '_text-gray-400': module.isDisabled }), checked: module.isChecked || false, indeterminate: module.isIndeterminate, disabled: module.isDisabled, onChange: handleChange }), (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _align-items-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "_text-1 _text-gray-500", children: t('content_list.total_pages', {
                                            amountToPluralize: module.totalPages,
                                            data: { amount: module.totalPages }
                                        }) }), showClassesTooltip && ((0, jsx_runtime_1.jsx)(classesModuleTooltip_1.default, { classHashIds: module.classHashIds, productId: productId, isLast: isLast }))] })] }) }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "custom", className: "_align-self _text-gray-900 _text-2 _border-0", disabled: module.isDisabled, onClick: handleClick, children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', isOpen ? 'chevron-up' : 'chevron-down'] }) }), isOpen && ((0, jsx_runtime_1.jsx)(modulePageList_1.ModulePageList, { module: module, isLoadingPages: isLoadingPages }))] }) }));
};
exports.default = (0, translate_1.translate)()(ModuleItem);
